import React, { useEffect, useState } from "react";
import AuctionsTab from "./AuctionsTab";
import axios from "axios";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const AuctionMap = () => {
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState([]);

  useEffect(() => {
    axios.get("/api/auction-product/all").then((res) => {
      if (res.data.status === 200) {
        setProduct(res.data.product);
        setLoading(false);
      }
    });
  }, []);

  return (
    <>
      {loading
        ? [...Array(4)].map((x, i) => (
          <SkeletonTheme baseColor="#202020" highlightColor="#444">
            <div className="row">
              <>
                <div className="col-md-6 col-sm-6 mb-3">
                  <div className="rounded">
                    <div className="bg-dark py-3 px-2 text-center">
                      <Skeleton width="100%" height={250} />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-md-6">
                  <div className="rounded">
                    <div className="bg-dark py-3 px-2">
                      <Skeleton width="100%" height={70} />
                      <Skeleton width="50%" height={50} />
                      <br />
                      <div className="row">
                        <div className="col-md-2">
                          <Skeleton circle height="60px" width="60px" />
                        </div>
                        <div className="col-md-10">
                          <Skeleton width="100%" className="" height={55} />
                        </div>
                      </div>

                      <Skeleton width="100%" className="" height={35} />
                    </div>
                  </div>
                </div>
              </>
            </div>
          </SkeletonTheme>
        ))
        : product.map((u) => <AuctionsTab key={u.id} user={u} />)}
    </>
  );
};

export default AuctionMap;
